import React, { useState } from 'react';
import styled from '@emotion/styled';
import { device } from '../../../../components/Print/device';
import Byline from 'routes/articleshow_v2/components/common/Byline';
import TimesPointHeaderWidget from 'routes/articleshow_v2/components/desktop/TimesPointHeaderWidget';
import SocialWidget from 'routes/articleshow_v2/components/desktop/SocialSharingWeb';
import EmailPrintFontOptions from 'routes/articleshow_v2/components/common/EmailPrintFontOptions';
import style from './Widget.scss';
import _get from 'lodash.get';
import s from '../../../articleshow_v2/components/common/SocialWidget/SocialWidget.scss';

interface IBylineAndSocialProps {
  articleShowData: { [key: string]: any }
  isWapView: boolean
  textSize: string | undefined
  changeSize: ((val: string) => void) | undefined
  scrollToBlocker: (() => void) | undefined
  isUserPrime: boolean
  msid: string
  comments: any
}

const BylineAndSocial = (props: IBylineAndSocialProps) => {
  const { articleShowData, isWapView, textSize, changeSize, isUserPrime, msid, comments } = props;
  const [showSocialWidget, setShowSocialWidget] = useState<boolean>(false);
  const categoryForGA = isWapView ? 'WAP-Printedprimeshow' : 'WEB-Printedprimeshow';
  const showSocialShareWidget = () => {
    setShowSocialWidget(true);
  };
  const hideSocialShareWidget = () => {
    setShowSocialWidget(false);
  };
  const getCommentsData = (msid: string) => {
    let commentCount = 0;
    if (comments && comments[`commentsData-${msid}`]) {
      const commentsData = comments[`commentsData-${msid}`];
      commentCount = commentsData[0] ? commentsData[0].totalcount : 0;
    }

    return commentCount;
  };
  const getSectionName = () => {
    const sectionName =
      articleShowData.navsubsecs &&
        articleShowData.navsubsecs.subsec1 &&
        articleShowData.navsubsecs.subsec1.subsecname1
        ? articleShowData.navsubsecs.subsec1.subsecname1
        : '';

    return sectionName.toLowerCase();
  }
  const getCommentModerationData = () => {
    return _get(articleShowData, 'metaInfo.CommentModeration', '');
  }
  return (
    <SeactionWrapper>
      <Byline
        ag={articleShowData.ag || ''}
        dl={articleShowData.dl || ''}
        dlStr={articleShowData.dlStr || ''}
        updStr={articleShowData.updStr || ''}
        upd={articleShowData.upd}
        isWapView={isWapView}
        sClassName="byline printarticle"
        author={articleShowData.authors}
        showCategory={isWapView}
        printLayout
        category={
          isWapView && articleShowData.bc &&
          articleShowData.bc.length > 0 &&
          articleShowData.bc[0].value
        }
        categoryLink={
          isWapView && articleShowData.bc &&
          articleShowData.bc.length > 0 &&
          articleShowData.bc[0].wu
        }
        navSubsection={
          !isWapView && articleShowData.navsubsecs &&
          articleShowData.navsubsecs.subsec2
        }
      />
      {!isWapView ? <WigetIconWrapper>
        <div data-socialshare={articleShowData.id}
          className="tp_widget_as"
        >
          <TimesPointHeaderWidget
            msid={articleShowData.id}
            title={articleShowData.hl}
            url={articleShowData.su || articleShowData.wu}
            wu={articleShowData.wu}
            isParent
            via={articleShowData.via}
            textRequired={false}
            tpShow
            linkeDin
            isWapView={isWapView}
            isSmallicon
            gaCategory={categoryForGA}
            gaAction="click"
            gaIndex="atfShare_"
            printLayout
          />
        </div>
        <div
          className={`${style.shareButtonWrapper} icon_share_wrap`}
          onMouseEnter={showSocialShareWidget}
          onMouseLeave={hideSocialShareWidget}
        >
          <div className={style.shareButton}>
            <i className={`${style.shareIcon} ${showSocialWidget ? style.active : ''}`} />
            <span>Share</span>
          </div>

          {showSocialWidget ? (
            <SocialWidget
              msid={articleShowData.id}
              url={articleShowData.su || articleShowData.wu}
              title={articleShowData.hl}
              className={'icon_hover_social'}
              isWapView={false}
              isSmallicon
              image={
                articleShowData.images
                  ? articleShowData.images[0]
                  : undefined
              }
              wu={articleShowData.wu}
              via={articleShowData.via}
              type="ATF"
              textRequired={false}
              linkeDin
              gaCategory={categoryForGA}
              gaAction="click"
              gaIndex="atfShare_"
              commentModeration={getCommentModerationData()}
              sectionName={getSectionName()}
              commentsCount={getCommentsData(msid)}
            // openSidebar={openSidebar}
            />) : null}

        </div>
        {isUserPrime ? <div data-socialshare={articleShowData.id}>
          <React.Fragment>
            <PrintIconWrapper>
              <EmailPrintFontOptions
                msid={articleShowData.id}
                url={articleShowData.su}
                title={articleShowData.hl}
                changeSize={changeSize}
                textSize={textSize}
                gaCategory={categoryForGA}
                showFontAlterOptions
                gaAction="click"
                gaLabel="atf"
                printLayout
              />
            </PrintIconWrapper>
          </React.Fragment>
        </div> : null}
      </WigetIconWrapper> : null}

    </SeactionWrapper>
  )
}

export default BylineAndSocial


const SeactionWrapper = styled.section`
  display: flex;
  align-items: center;
  margin: 16px 0 0 0;
  justify-content: space-between;
  @media screen and ${device.mobile},
    screen and (orientation: landscape) and (max-width: 1000px) {
      margin: 8px 0 0 0;
    }
`

const WigetIconWrapper = styled.section`
  display: flex;
  flex-flow: row;
  & > div{
    margin-right: 8px;
  }
  & > div:last-child{
    margin-right: 0;
  }
`
const LeadImageWrapper = styled.section`
  margin: 20px 0 0 0;
`

const PrintIconWrapper = styled.section`
  display: flex;

  &>a{
    display: inline-block;
    margin: 0 10px 0 0;
  }
`